import { Badge } from '@/components/ui/badge'
import type { Agent } from '@/types'
import { agentCategory } from '@/types'

const NEUTRAL_BORDER = 'rgba(118,124,150,1)'

export function AgentCategoryBadge({ agent }: { agent: Pick<Agent, 'isGlobal'> }) {
  return (
    <Badge variant="outline" className="text-xs" style={{ borderColor: NEUTRAL_BORDER }}>
      {agentCategory(agent)}
    </Badge>
  )
}

export function AgentVersionBadge({ version }: { version: string }) {
  return (
    <Badge variant="outline" className="text-xs font-mono" style={{ borderColor: NEUTRAL_BORDER }}>
      v{version}
    </Badge>
  )
}
